export const ALERT_COMMENT_MAX_LENGTH = 2000;

export const COMMENT_TOO_LONG_MESSAGE =
  "Comment can't be longer than 2,000 characters";

/** Length of the text inside editor HTML; tags and entities do not count. */
export const getCommentTextLength = (html: string): number => {
  if (!html) return 0;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent ?? '').length;
};
